import { getError } from "@/utils/helpers";
import NplanBvService from "@/services/nplan/NplanBvService";
export const namespaced = true;

export const state = {
  bv_plans: [],
  loading: false,
  error: null,
  status: null,
};

export const mutations = {
  SET_BVPLANS(state, bv_plans) {
    state.bv_plans = bv_plans;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getBVplans({ commit }) {
    commit("SET_LOADING", true);

    NplanBvService.getMains()
      .then((response) => {
        commit("SET_BVPLANS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_BVPLANS", []);
  },
};
export const getters = {
  bv_plans: (state) => {
    return state.bv_plans;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
